import React, { useEffect, useState } from "react";
import FormEmptyState from "../../ShareElements/EmptyState/FormEmptyState";
import SearchInput from "../../ShareElements/SearchInput/SearchInput";
import RowItem from "./Components/RowItem";
import Select from "../../ShareElements/Select/Select";
import UnsavedChangesAlert from "../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import { Config } from "../../../../../Config";
import axios from "axios";
import { translateText } from "../../../../../Helper_functions";

const LocalizationForm = (props) => {
  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
  ]);
  const [Pages, setPages] = useState([1]);
  const [PageInfo, setPageInfo] = useState({});
  const [ResetType, setResetType] = useState("CATEGORY"); // either "CATEGORY" or "ALL"
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [ActivePageNum, setActivePageNum] = useState(1);

  useEffect(() => {
    createPagination();
  }, [props.Labels, props.TotalElements]);

  useEffect(() => {
    document.getElementById("nav-menu-tab").click();
  }, []);

  const createPagination = () => {
    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page") !== null) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }
    let Count = Math.ceil(props.TotalElements / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };
  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
  };

  const requestPageNumber = (PageNumber) => {
    setActivePageNum(PageNumber);

    props.SetEditIsActive(false);
    props.SetItemToEdit(undefined);

    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);

    if (props.SearchIsOpen) {
      props.SearchLabels(undefined, null, false, Size, NewStart);
    } else {
      props.SearchLabels(
        undefined,
        props.SelectedCategory.id,
        false,
        Size,
        NewStart
      );
    }

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
      updateActiveClass(1);
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (
      parseInt(document.getElementById("end").innerHTML) ===
      parseInt(props.TotalElements)
    ) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else if (
      parseInt(document.getElementById("end").innerHTML) >
      parseInt(props.TotalElements)
    ) {
      document.getElementById("end").innerHTML = props.TotalElements;
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    if (document.getElementById(PageNumber + "-page-btn")) {
      document
        .getElementById(PageNumber + "-page-btn")
        .classList.add("active-page");
    }
  };

  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };

  const setSize = () => {
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const displayEndNumber = () => {
    let Start = 0;
    if (document.getElementById("start")) {
      Start = parseInt(document.getElementById("start").innerHTML);
    }
    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page")) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }

    if (
      Pages.length === 1 ||
      props.TotalElements < Start + Size ||
      Start === 0
    ) {
      return <p id="end">{props.TotalElements}</p>;
    } else {
      return <p id="end">5</p>;
    }
  };

  const searchItem = () => {
    let Start = 0;
    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page")) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }

    props.SetEditIsActive(false);
    props.SetItemToEdit(undefined);

    if (document.getElementById("search-input").value.length > 0) {
      props.SetSearchIsOpen(true);
      if (document.getElementById("1-page-btn")) {
        document.getElementById("1-page-btn").click();
      } else {
        props.SearchLabels(undefined, null, false, Size, Start);
      }
    } else {
      props.SetSearchIsOpen(false);
      props.SearchLabels(undefined, null, true, Size, Start);

      if (document.getElementById("start")) {
        document.getElementById("start").innerHTML = 1;
      }
      createPagination();
    }
  };

  const toggleEdit = (Item) => {
    props.SetEditIsActive(true);
    props.SetItemToEdit(Item);
  };

  const cancelEdit = () => {
    let Start = 0;
    if (document.getElementById("start")) {
      Start = parseInt(document.getElementById("start").innerHTML - 1);
    }
    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page")) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }

    props.SetEditIsActive(false);
    if (props.SearchIsOpen) {
      props.SearchLabels(undefined, null, false, Size, Start);
    } else {
      props.SearchLabels(
        undefined,
        props.SelectedCategory.id,
        false,
        Size,
        Start
      );
    }

    props.SetItemToEdit(undefined);
  };

  const displayModal = (Type) => {
    setResetType(Type);
    setModalIsOpen(true);
  };

  const resetLabels = () => {
    let Categories = [];
    if (ResetType === "CATEGORY") {
      Categories.push(props.SelectedCategory.id);
    } else {
      props.Categories.map((Cat) => {
        Categories.push(Cat.id);
      });
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/labels/bulk-reset",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        labelCategories: [...Categories],
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setModalIsOpen(false);
        document.getElementById(ActivePageNum + "-page-btn").click();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  return (
    <div
      className={
        props.ResIsEmpty ? "localization-form-empty" : "localization-form"
      }
    >
      {ModalIsOpen ? (
        <UnsavedChangesAlert
          LangData={props.LangData}
          AlertMessage={
            ResetType === "ALL"
              ? translateText("reset_all_text", props.LangData)
              : translateText("reset_category_text", props.LangData)
          }
          CancelText={translateText("cancel", props.LangData)}
          SaveText={translateText("confirm", props.LangData)}
          ModalTitle={
            ResetType === "ALL"
              ? translateText("reset_all", props.LangData)
              : translateText("reset_category", props.LangData)
          }
          close={() => setModalIsOpen(false)}
          save={() => resetLabels()}
        />
      ) : null}
      <>
        <section className="reset-actions-wrapper">
          <span
            className={
              props.SearchIsOpen ? "action-btn disabled" : "action-btn"
            }
            onClick={() =>
              !props.SearchIsOpen ? displayModal("CATEGORY") : null
            }
          >
            {translateText("reset_category", props.LangData)}
          </span>
          <span className="action-btn" onClick={() => displayModal("ALL")}>
            {translateText("reset_all", props.LangData)}
          </span>
        </section>
        <section className="form-head">
          <>
            {props.SearchIsOpen && !props.ResIsEmpty ? (
              <h1>
                {translateText("all_results_for", props.LangData) +
                  " " +
                  '"' +
                  document.getElementById("search-input").value +
                  '"'}
              </h1>
            ) : (
              <h1>{props.ResIsEmpty ? null : props.SelectedCategory.name}</h1>
            )}
          </>
          <SearchInput
            OnChange={() => searchItem()}
            Placeholder={translateText("search", props.LangData) + " ..."}
          />
        </section>
        {props.ResIsEmpty ? (
          <FormEmptyState
            Message={
              translateText("localization_empty_state", props.LangData) + "."
            }
            ActionButton={null}
          />
        ) : (
          <>
            {props.Labels.map((Item, i) => (
              <div className="form-body">
                <>
                  <RowItem
                    AllLangData={props.AllLanguages}
                    LangData={props.LangData}
                    Name={Item.labelValue}
                    LabelId={Item.labelId}
                    Id={"row-" + i}
                    ToggleEdit={() => toggleEdit(Item)}
                    EditIsActive={props.EditIsActive}
                    ItemToEdit={props.ItemToEdit}
                    Categories={props.Categories}
                    Cat_Id={props.Cat_Id}
                    Category={props.Category}
                    LangOptions={props.LangOptions}
                    CancelEdit={() => cancelEdit()}
                    SaveLabel={(Label) => props.SaveLabel(Label)}
                    LabelItem={Item}
                    SetEditIsActive={(Bool) => props.SetEditIsActive(Bool)}
                    SelectedCategory={props.SelectedCategory}
                    SecondLangLabels={props.SecondLangLabels}
                    SearchLabels={(Lang, Category) =>
                      props.SearchLabels(Lang, Category)
                    }
                    Pages={Pages}
                  />
                  <div className="line"></div>
                </>
              </div>
            ))}
          </>
        )}
      </>
      <>
        {props.ResIsEmpty ? null : (
          <div className="info-footer" id="info-footer">
            <div className="pagenumber-summary">
              {translateText("showing", props.LangData)}
              <p id="start">1</p>
              {translateText("to", props.LangData)}
              {displayEndNumber()}
              {translateText("of", props.LangData)}
              {" " + props.TotalElements + " "}
              {translateText("items", props.LangData)}.
            </div>
            <section className="pagination-holder">
              <button
                onClick={() => requestPrevPage()}
                id="prev-page"
                className="page-btn page-btn-disabled"
              >
                <i className="feather-chevron-left"></i>
              </button>
              <>
                {Pages.length < 6 ? (
                  <>
                    {Pages.map((Page) => (
                      <>
                        {Page === 1 ? (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn active-page"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        ) : (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        )}
                      </>
                    ))}
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => requestPageNumber(1)}
                      className="page-btn active-page"
                      id={1 + "-page-btn"}
                    >
                      {1}
                    </button>
                    {PageInfo.FirstDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() =>
                        requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                      }
                      className="page-btn"
                      id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                    >
                      {parseInt(PageInfo.MiddlePage - 1)}
                    </button>
                    {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                      <button
                        onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                        className="page-btn"
                        id={PageInfo.MiddlePage + "-page-btn"}
                      >
                        {PageInfo.MiddlePage}
                      </button>
                    )}
                    {parseInt(PageInfo.MiddlePage + 1) >=
                    PageInfo.LastPage ? null : (
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                        }
                        className="page-btn "
                        id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage + 1)}
                      </button>
                    )}
                    {!PageInfo.LastDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() => requestPageNumber(PageInfo.LastPage)}
                      className="page-btn"
                      id={PageInfo.LastPage + "-page-btn"}
                    >
                      {PageInfo.LastPage}
                    </button>
                  </>
                )}
              </>
              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className="page-btn"
              >
                <i className="feather-chevron-right"></i>
              </button>
            </section>
            <div className="row-count-select">
              <p className="row-info">
                {translateText("rows_per_page", props.LangData)}
              </p>
              <Select
                Initial={"5"}
                Options={SizeOptions}
                IsWithId
                PreSelectedId="5"
                Id={"row-per-page"}
                ChangeHandler={() =>
                  setTimeout(() => {
                    setSize();
                  }, 100)
                }
                ValidationError=""
              />
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default LocalizationForm;
